module.exports = __webpack_public_path__ + "static/img/star-year-header.e95bf1df.png";